<div class="flex reset-password-background" [class.centralizado]="motoristasFiltrados.length === 0">
  <div class="card motorista-card">

    <div class="card-header" style="text-align: center; margin-bottom: 12px;">
      <div style="display: inline-flex; align-items: center; gap: 10px; white-space: nowrap;">
        <h2 style="margin: 0; font-size: 1.1rem; color: #333;"><strong>InnovaTransit</strong></h2>
        <span style="font-size: 0.9rem; color: #1b1b1b; opacity: 0.8; font-weight: 500;">v1.15.1</span>
      </div>
    </div>

    <div class="card-body">

      <!-- Alerta de Folhas Pendentes de Assinatura -->
      <div class="alerta-pendentes-overlay" *ngIf="mostrarAlertaPendentes">
        <div class="alerta-pendentes-card">
          <div class="alerta-icon">
            <ion-icon name="warning-outline"></ion-icon>
          </div>
          <div class="alerta-content">
            <h3>Atenção!</h3>
            <p [innerHTML]="mensagemAlertaPendentes"></p>
          </div>
          <div class="alerta-buttons">
            <button class="btn-entendi" (click)="fecharAlertaPendentes()">
              <ion-icon name="checkmark-circle-outline"></ion-icon>
              OK, entendi
            </button>
          </div>
        </div>
      </div>
      <ion-button fill="clear" size="small" color="medium" (click)="limparServidor()"
        style="position: absolute; top: 10px; left: 10px; opacity: 0; width: 32px; height: 32px;">
        <ion-icon slot="icon-only" name="trash"></ion-icon>
        limpar
      </ion-button>

      <div class="search-container">
        <div class="search-row">
          <input type="text" class="search-input" placeholder="Digite sua matrícula" [(ngModel)]="searchTerm"
            (input)="filtrarMotoristas()" />
          <ion-button fill="solid" color="primary" (click)="fazerLogin()" size="small" class="btn-login">
            Login
          </ion-button>
          <ion-button fill="solid" (click)="sair()" size="small" class="btn-sair">
            Sair
          </ion-button>
          <ion-button *ngIf="tokenAutenticacao && motoristas.length > 0" fill="solid" (click)="abrirProximasEscalas()"
            size="small" class="btn-escl">
            <ion-icon name="calendar-outline" slot="start"></ion-icon>
            Próximas Escalas
          </ion-button>
          <ion-button *ngIf="tokenAutenticacao && motoristas.length > 0" fill="solid" (click)="abrirPapeletaExterna()"
            size="small" class="btn-escla">
            <ion-icon name="document-text-outline" slot="start"></ion-icon>
            Papeletas Externas
          </ion-button>
          <ion-button *ngIf="!tokenAutenticacao" fill="solid" color="medium" (click)="abrirAjudaLogin()" size="small"
            class="btn-ajuda">
            Ajuda
          </ion-button>
        </div>
      </div>

      <div class="table-container">
        <table class="motorista-table">
          <thead>
            <tr>
              <th>Nome</th>
              <th>Matrícula</th>
              <th>Papeleta</th>
              <th>Data</th>
              <th>Veículo</th>
              <th>Início 1</th>
              <th>Fim 1</th>
              <th>Início 2</th>
              <th>Fim 2</th>
              <th>Ação</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let motorista of motoristasFiltrados">
              <!-- Linha principal com os dados -->
              <tr class="motorista-principal">
                <td data-label="Nome">{{ motorista.nome }}</td>
                <td data-label="Matrícula">{{ motorista.matricula }}</td>
                <td data-label="Papeleta">{{ motorista.papeleta }}</td>
                <td data-label="Data">{{ motorista.dataServico | date:'dd/MM/yyyy' }}</td>
                <td data-label="Veículo" class="veiculo-destaque veiculo-clicavel"
                  (click)="obterLocalizacaoVeiculo(motorista)">{{ motorista.veiculo }}</td>
                <td data-label="Início 1">{{ motorista.horarioInicial }}</td>
                <td data-label="Fim 1">{{ motorista.horarioFinal1 }}</td>
                <td data-label="Início 2">{{ motorista.horarioInicial2 }}</td>
                <td data-label="Fim 2">{{ motorista.horarioFinal }}</td>
                <td data-label="Ação" class="acoes-cell">
                  <div class="botoes-acoes" *ngIf="exibirBotoesJornadaNormal">
                    <ion-button *ngIf="botaoStatus[motorista.idFolhaServico]" fill="outline"
                      (click)="iniciarDireto(motorista)" size="small">
                      Iniciar
                    </ion-button>
                    <ion-button *ngIf="!botaoStatus[motorista.idFolhaServico]" color="danger" fill="outline"
                      (click)="finalizarDireto(motorista)" size="small">
                      Finalizar
                    </ion-button>

                  </div>
                  <div class="botoes-acoes">
                    <ion-button color="success" fill="outline" size="small" (click)="visualizarPDF(motorista)">
                      Papeleta
                    </ion-button>
                  </div>
                </td>
              </tr>

              <!-- Linha das mensagens do motorista -->
              <tr *ngIf="mensagensMotorista.length > 0">
                <td colspan="10" class="mensagens-container">
                  <div class="mensagens-wrapper">
                    <div class="mensagens-titulo">
                      <ion-icon name="chatbubbles-outline"></ion-icon>
                      <span>Mensagens</span>
                    </div>
                    <div class="mensagens-list">
                      <div *ngFor="let msg of mensagensMotorista" class="mensagem-item">
                        <span class="mensagem-texto">{{ msg.mensagem }}</span>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>

              <!-- Linha dos acertos de hora -->
              <tr *ngIf="acertosHorarios.length > 0">
                <td colspan="10" class="acertos-container">
                  <div class="acertos-wrapper">
                    <div class="acertos-titulo">Horários Registrados</div>
                    <div class="acertos-grid">
                      <ng-container *ngFor="let grupo of getAcertosAgrupados()">
                        <div class="acertos-linha">
                          <div *ngFor="let acerto of grupo" class="acerto-item">
                            <span class="acerto-hora">{{ formatarHoraExibicao(acerto.hora) }}</span>
                            <span class="acerto-status">{{ acerto.statusAcertoHora }}</span>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </td>
              </tr>

              <!-- Linha extra com os botões Assinar e Corrigir - FIXA -->
              <!--<tr>
                <td colspan="10">
                  <div class="botoes-extras-fixo">
                    <div class="botoes-extras">
                      
                      <button *ngIf="impressoraConectada" (click)="conectarImpressora()">
                        🔌Conectar Impressora Elgin
                      </button>
                      <span class="status-ok">
                        🟢 Impressora Pronta
                      </span>
                      <ion-button color="success" size="small" (click)="imprimir(motorista)">
                        Imprimir
                      </ion-button>
                      <ion-button color="success" size="small" (click)="abrirCorrecaoHorario(motorista)">
                        Corrigir hora
                      </ion-button>
                      <ion-button *ngIf="!temAssinatura(motorista)" color="primary" size="small"
                        (click)="assinarPapeleta(motorista)">
                        Assinar Papeleta
                      </ion-button>

                      <ion-button *ngIf="temAssinatura(motorista)" color="secondary" size="small"
                        (click)="solicitarExclusaoAssinatura(motorista)">
                        Excluir assinatura
                      </ion-button>
                    </div>
                  </div>
                </td>
              </tr>-->
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- ===== RODAPÉ FIXO COM OS BOTÕES ===== -->
  <div class="footer-actions" *ngIf="motoristasFiltrados.length > 0">
    <div class="footer-content">
      <ng-container *ngFor="let motorista of motoristasFiltrados">
        <!-- Botão obrigatório caso a impressora perca a conexão ou seja a primeira vez -->
        <button *ngIf="impressoraConectada" (click)="conectarImpressora()" class="btn-footer">
          🔌Conectar
        </button>
        <span class="status-ok-footer">
          🟢 Pronta
        </span>
        <ion-button color="success" size="small" (click)="imprimir(motorista)" class="btn-footer">
          Imprimir
        </ion-button>
        <ion-button color="success" size="small" (click)="abrirCorrecaoHorario(motorista)" class="btn-footer">
          Corrigir hora
        </ion-button>
        <!-- Botão ASSINAR - aparece apenas quando NÃO tem assinatura -->
        <ion-button *ngIf="!temAssinatura(motorista)" color="primary" size="small" (click)="assinarPapeleta(motorista)"
          class="btn-footer">
          Assinar
        </ion-button>
        <!-- Botão EXCLUIR ASSINATURA - aparece apenas quando TEM assinatura -->
        <ion-button *ngIf="temAssinatura(motorista)" color="secondary" size="small"
          (click)="solicitarExclusaoAssinatura(motorista)" class="btn-footer">
          Excluir assinatura
        </ion-button>
        <ion-button *ngIf="tokenAutenticacao" color="medium" size="small" (click)="abrirAjudaJornada()"
          class="btn-footer btn-ajuda-footer">
          Ajuda
        </ion-button>
      </ng-container>
    </div>
  </div>

  <div class="mini-card" *ngIf="mostrarSenha">
    <div class="mini-card-body">
      <h3 class="mini-card-title">Confirmação de Login</h3>
      <p class="mini-card-text">Digite sua senha para confirmar a ação:</p>

      <div class="mini-card-input">
        <ion-item class="password-item">
          <ion-input [type]="showPassword ? 'text' : 'password'" [(ngModel)]="senhaDigitada" placeholder="Senha"
            label="Senha" labelPlacement="floating">
          </ion-input>

          <div class="eye-icon" (click)="togglePassword()">
            <img [src]="showPassword ? 'assets/icon/olho-aberto.png' : 'assets/icon/olho.png'"
              alt="Mostrar ou ocultar senha" />
          </div>
        </ion-item>
      </div>


      <div class="mini-card-actions">
        <ion-button expand="block" color="success" (click)="validarSenha()">Confirmar</ion-button>
        <ion-button expand="block" color="medium" (click)="cancelarSenha()">Cancelar</ion-button>
      </div>
    </div>
  </div>

  <!-- Pop-up de Confirmação para Assinar (principal) -->
  <div class="mini-card" *ngIf="mostrarConfirmacaoAssinatura && !diaParaAssinar">
    <div class="mini-card-body">
      <h3 class="mini-card-title">Confirmação de Assinatura</h3>
      <p class="mini-card-text">Você concorda com todos os horários marcados?</p>

      <div class="mini-card-actions">
        <ion-button expand="block" color="success" (click)="confirmarAssinatura()">Confirmar</ion-button>
        <ion-button expand="block" color="medium" (click)="cancelarAssinatura()">Cancelar</ion-button>
      </div>
    </div>
  </div>

  <!-- Pop-up de Confirmação para Assinar (modal de correção) -->
  <div class="mini-card" *ngIf="mostrarConfirmacaoAssinatura && diaParaAssinar">
    <div class="mini-card-body">
      <h3 class="mini-card-title">Confirmação de Assinatura</h3>
      <p class="mini-card-text">
        Você concorda com todos os horários da papeleta do dia
        {{ diaParaAssinar.data | date:'dd/MM/yyyy' }}?
      </p>

      <div class="mini-card-actions">
        <ion-button expand="block" color="success" (click)="confirmarAssinaturaDia()">Confirmar</ion-button>
        <ion-button expand="block" color="medium" (click)="cancelarAssinaturaDia()">Cancelar</ion-button>
      </div>
    </div>
  </div>

  <!-- Modal de Correção de Horário -->
  <div class="modal-overlay" *ngIf="mostrarModalCorrecao" (click)="fecharModalCorrecao()">
    <div class="modal-container" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>📅 Correção de Horários</h3>
        <button class="btn-close" (click)="fecharModalCorrecao()">✕</button>
      </div>

      <div class="modal-body">
        <div class="progress-bar" *ngIf="isLoadingCorrecao">Carregando...</div>

        <!-- Cabeçalho do funcionário -->
        <div class="funcionario-header-modal" *ngIf="motoristaParaAssinar">
          <div class="funcionario-info">
            <div class="funcionario-detalhes">
              <strong>{{ motoristaParaAssinar.nome }}</strong>
              <span>Matrícula: {{ motoristaParaAssinar.matricula }}</span>
            </div>
          </div>
        </div>

        <!-- Filtros -->
        <div class="filtros-dias">
          <div class="filtros-tabs">
            <button class="tab-btn" [class.active]="filtroAtualCorrecao === 'todos'"
              (click)="filtrarDiasCorrecao('todos')">
              Todos ({{ totalDiasCorrecao }})
            </button>
          </div>
        </div>

        <!-- Tabela de Dias -->
        <div class="dias-apurados-panel">
          <div class="panel-header">
            <h3>📋 DIAS APURADOS (Últimos 30 dias)</h3>
          </div>

          <div class="table-wrapper">
            <table class="dias-table">
              <thead>
                <tr>
                  <th>Data</th>
                  <th>Marcações</th>
                  <th>Situações</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let dia of getDiasPaginadosCorrecao()">
                  <td class="data-cell">
                    <div class="data-container">
                      <div class="data-info">
                        <strong class="data-dia">{{ dia.data | date:'dd/MM/yyyy' }}</strong>
                        <span class="dia-semana">{{ getDiaSemana(dia.data) }}</span>
                      </div>
                      <div class="papeleta-info" *ngIf="dia.papeleta">
                        <ion-icon name="document-text-outline" class="papeleta-icon"></ion-icon>
                        <span class="papeleta-numero">Papeleta: {{ dia.papeleta }}</span>
                      </div>
                    </div>
                  </td>
                  <td class="marcacoes-cell">
                    <!-- Verifica se a papeleta já está assinada -->
                    <ng-container *ngIf="getStatusDia(dia) as status">

                      <!-- Se NÃO está assinada, mostra os botões de edição/exclusão/adicionar -->
                      <ng-container *ngIf="status.podeSolicitarExclusao === false && status.podeAssinar === true">

                        <!-- Lista de marcações existentes com botões de edição/exclusão -->
                        <div *ngFor="let marcacao of dia.marcacoes" class="marcacao-item">
                          <div *ngIf="editandoAcertoId === marcacao.acertoId; else visualizacao" class="edicao-acerto">
                            <input type="text" [(ngModel)]="acertoEditando!.hora"
                              (input)="formatarHoraEstendida($event)" placeholder="HH:mm" maxlength="5"
                              class="input-hora-estendida" />
                            <select [(ngModel)]="acertoEditando!.motivoId">
                              <option [ngValue]="null">Selecione um motivo...</option>
                              <option *ngFor="let motivo of motivosDisponiveis" [ngValue]="motivo.id">
                                {{ motivo.descricao }}
                              </option>
                            </select>
                            <button (click)="salvarEdicaoAcerto(dia, marcacao)">💾</button>
                            <button (click)="cancelarEdicaoAcerto()">✕</button>
                          </div>
                          <ng-template #visualizacao>
                            <div class="marcacao-info">
                              <span class="marcacao-hora">{{ formatarHoraParaExibicao(marcacao.hora,
                                marcacao.acertoData
                                ||
                                dia.data, dia.data) }}
                              </span>
                              <span class="marcacao-status">{{ marcacao.status || 'Pendente' }}</span>
                              <span class="marcacao-motivo" *ngIf="marcacao.motivo">
                                {{ getJustificativaDescricao(marcacao.motivo) }}
                              </span>
                              <div class="marcacao-acoes">
                                <!--<button *ngIf="marcacao.status !== 'Marcado'"
                                  (click)="iniciarEdicaoAcerto(marcacao.acertoId!, marcacao.hora, marcacao.motivo ? +marcacao.motivo : undefined)">✏️</button>-->
                                <button (click)="excluirAcerto(dia, marcacao)" class="btn-action btn-danger"
                                  title="Excluir">
                                  <ion-icon name="trash-outline"></ion-icon>
                                </button>
                              </div>
                            </div>
                          </ng-template>
                        </div>

                        <!-- Botão para adicionar (só aparece quando NÃO está assinada) -->
                        <div class="adicionar-marcacao">
                          <ion-button (click)="abrirNovaMarcacao(dia)" color="primary" size="small">Adicionar
                            acerto</ion-button>
                        </div>

                        <!-- Formulário de nova marcação -->
                        <div class="nova-marcacao-form"
                          *ngIf="mostrarNovaMarcacao && diaSelecionadoParaAdicionar === dia">
                          <div class="form-fields">
                            <input type="text" [(ngModel)]="novaMarcacao.hora"
                              (input)="formatarHoraEstendidaNova($event)" placeholder="HH:mm" maxlength="5"
                              class="input-hora-estendida" />
                            <select [(ngModel)]="novaMarcacao.motivoId">
                              <option [ngValue]="null">Selecione um motivo...</option>
                              <option *ngFor="let motivo of motivosDisponiveis" [ngValue]="motivo.id">
                                {{ motivo.descricao }}
                              </option>
                            </select>
                            <div class="form-buttons">
                              <button (click)="salvarNovaMarcacao()">✓ Salvar</button>
                              <button (click)="fecharNovaMarcacao()">✕ Cancelar</button>
                            </div>
                          </div>
                        </div>
                      </ng-container>

                      <!-- Se ESTÁ assinada (ou com solicitação pendente), mostra apenas as marcações sem botões -->
                      <ng-container
                        *ngIf="status.podeSolicitarExclusao === true || (status.podeAssinar === false && status.podeSolicitarExclusao === false)">
                        <!-- Lista de marcações existentes SEM botões de edição/exclusão -->
                        <div *ngFor="let marcacao of dia.marcacoes" class="marcacao-item-readonly">
                          <div class="marcacao-info-readonly">
                            <span class="marcacao-hora">{{ formatarHoraParaExibicao(marcacao.hora, marcacao.acertoData
                              ||
                              dia.data, dia.data) }}
                            </span>
                            <span class="marcacao-status">{{ marcacao.status || 'Pendente' }}</span>
                            <span class="marcacao-motivo" *ngIf="marcacao.motivo">
                              {{ getJustificativaDescricao(marcacao.motivo) }}
                            </span>
                          </div>
                        </div>

                        <!-- Mensagem informativa quando a papeleta está assinada -->
                        <div class="assinada-mensagem" *ngIf="status.podeSolicitarExclusao === true">
                          <small>⚠️ Papeleta assinada. Para alterar os horários, solicite exclusão da
                            assinatura.</small>
                        </div>
                        <div class="pendente-mensagem"
                          *ngIf="status.podeAssinar === false && status.podeSolicitarExclusao === false && status.statusSolicitacao === 'PENDENTE'">
                          <small>⏳ Aguardando análise da solicitação de exclusão.</small>
                        </div>
                      </ng-container>

                    </ng-container>
                  </td>
                  <td class="situacoes-cell">
                    <div *ngFor="let situacao of dia.situacoes">
                      <span>{{ situacao.descricao }}</span>
                      <span *ngIf="situacao.tipo">({{ situacao.tipo }})</span>
                    </div>
                  </td>
                  <td class="acoes-cell">
                    <ng-container *ngIf="getStatusDia(dia) as status">
                      <ion-button (click)="acaoPapeletaDoDia(dia)" [color]="status.corBotao" size="small"
                        [disabled]="status.desabilitado">
                        <ion-icon *ngIf="status.textoBotao === 'Assinar Papeleta'" name="create-outline"
                          slot="start"></ion-icon>
                        <ion-icon *ngIf="status.textoBotao === 'Solicitar Exclusão'" name="trash-outline"
                          slot="start"></ion-icon>
                        <ion-icon *ngIf="status.textoBotao === 'Aguardando Exclusão'" name="hourglass-outline"
                          slot="start"></ion-icon>
                        <ion-icon *ngIf="status.textoBotao === 'Erro'" name="alert-circle-outline"
                          slot="start"></ion-icon>
                        {{ status.textoBotao }}
                      </ion-button>
                      <div *ngIf="status.mensagem" class="status-mensagem"
                        style="font-size: 10px; color: #666; margin-top: 4px;">
                        {{ status.mensagem }}
                      </div>
                    </ng-container>
                  </td>
                </tr>
                <tr *ngIf="getDiasPaginadosCorrecao().length === 0">
                  <td colspan="4">Nenhum dia encontrado.</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Paginação -->
          <div class="pagination-container" *ngIf="diasFiltradosCorrecao.length > itensPorPaginaCorrecao">
            <span>Mostrando {{ ((paginaAtualCorrecao - 1) * itensPorPaginaCorrecao) + 1 }} a {{
              Math.min(paginaAtualCorrecao * itensPorPaginaCorrecao, diasFiltradosCorrecao.length) }} de {{
              diasFiltradosCorrecao.length }} registros</span>
            <div>
              <button (click)="paginaAnteriorCorrecao()" [disabled]="paginaAtualCorrecao === 1">◀</button>
              <span>Página {{ paginaAtualCorrecao }} de {{ totalPaginasCorrecao }}</span>
              <button (click)="proximaPaginaCorrecao()"
                [disabled]="paginaAtualCorrecao === totalPaginasCorrecao">▶</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button (click)="fecharModalCorrecao()">Fechar</button>
      </div>
    </div>
  </div>

  <ion-toast [isOpen]="showToast" position="top" [message]="toastMessage" duration="3000" cssClass="toast-message"
    (didDismiss)="showToast = false">
  </ion-toast>

  <app-proximas-escalas-modal [isOpen]="mostrarModalEscalas" [motorista]="motoristas.length > 0 ? motoristas[0] : null"
    (closeModal)="fecharModalEscalas()">
  </app-proximas-escalas-modal>

  <!-- Modal Papeleta Externa -->
  <div class="modal-overlay" *ngIf="mostrarModalPapeletaExterna" (click)="fecharPapeletaExterna()">
    <div class="modal-container" (click)="$event.stopPropagation()">

      <div class="modal-header">
        <h3>📄 Papeleta Externa</h3>
        <button class="btn-close" (click)="fecharPapeletaExterna()">✕</button>
      </div>

      <div class="modal-body">

        <!-- Carregando -->
        <div *ngIf="papeletaExternaCarregando" style="text-align: center; padding: 40px;">
          <ion-spinner name="crescent"></ion-spinner>
          <p style="margin-top: 16px; color: #666;">Carregando papeleta...</p>
        </div>

        <!-- Sem dados -->
        <div *ngIf="!papeletaExternaCarregando && papeletaExternaSemDados" style="text-align: center; padding: 40px;">
          <ion-icon name="information-circle-outline" style="font-size: 64px; color: #ff9800;"></ion-icon>
          <p style="margin-top: 16px; color: #666; font-size: 15px;">
            Você não possui papeleta externa para esta data.
          </p>
        </div>

        <!-- Conteúdo -->
        <div *ngIf="!papeletaExternaCarregando && folhaExterna">

          <ion-grid>
            <ion-row>
              <ion-col size="6" size-sm="3">
                <ion-item>
                  <ion-input label="Veículo:" [value]="folhaExterna.veiculo?.numeroVeiculo ?? '-'"
                    [readonly]="true"></ion-input>
                </ion-item>
              </ion-col>
              <ion-col size="6" size-sm="3">
                <ion-item>
                  <ion-input label="Data:" [value]="folhaExterna.dataServico | date:'dd/MM/yyyy'"
                    [readonly]="true"></ion-input>
                </ion-item>
              </ion-col>
              <ion-col size="6" size-sm="3">
                <ion-item>
                  <ion-input label="Hr. Início:" [value]="folhaExterna.horarioInicial" [readonly]="true"></ion-input>
                </ion-item>
              </ion-col>
              <ion-col size="6" size-sm="3">
                <ion-item>
                  <ion-input label="Hr. Final:"
                    [value]="folhaExterna.horarioFinal !== '00:00' ? folhaExterna.horarioFinal : folhaExterna.horarioFinal1"
                    [readonly]="true"></ion-input>
                </ion-item>
              </ion-col>
              <ion-col size="6" size-sm="3">
                <ion-item>
                  <ion-input label="Pap:" [value]="folhaExterna.papeleta" [readonly]="true"></ion-input>
                </ion-item>
              </ion-col>
              <ion-col size="6" size-sm="3">
                <ion-item>
                  <ion-input label="Serviço:" [value]="folhaExterna.numeroServico" [readonly]="true"></ion-input>
                </ion-item>
              </ion-col>
              <ion-col size="6" size-sm="3">
                <ion-item>
                  <ion-input label="Garagem:"
                    [value]="folhaExterna.garagem ? (folhaExterna.garagem.descricao || folhaExterna.garagem.id) : '-'"
                    [readonly]="true"></ion-input>
                </ion-item>
              </ion-col>
              <ion-col size="6" size-sm="3">
                <ion-item>
                  <ion-input label="Colaborador:" [value]="folhaExterna.matricula" [readonly]="true"></ion-input>
                </ion-item>
              </ion-col>
            </ion-row>
          </ion-grid>

          <!-- Tabela de Tarefas -->
          <div class="table-wrapper" style="margin-top: 16px;">
            <table class="dias-table">
              <thead>
                <tr>
                  <th>Linha</th>
                  <th>Evento</th>
                  <th>Início</th>
                  <th>Fim</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let tarefa of listaTarefasExterna">
                  <td>{{ formatarLinhaPrefixoExterna(tarefa.linhaPrefixo) }}</td>
                  <td>{{ tarefa.evento }}</td>
                  <td>{{ formatarHoraExterna(tarefa.horarioInicio) }}</td>
                  <td>{{ formatarHoraExterna(tarefa.horarioFim) }}</td>
                </tr>
                <tr *ngIf="!listaTarefasExterna.length">
                  <td colspan="4" style="text-align: center;">Nenhuma tarefa registrada</td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>

      <div class="modal-footer">
        <button (click)="fecharPapeletaExterna()">Fechar</button>
      </div>

    </div>
  </div>

</div>